
import Vue from 'vue'
import Hit from './Hit.vue'
interface HitListProps {
	
}

export default Vue.extend<{}, {}, {}, HitListProps>({
	name: 'HitList',
	props: {
		
	},
    computed: {
        hits() {
            console.log('this.$store.getters.hits: ' + JSON.stringify(this.$store.getters.hits))
            return this.$store.getters.hits
        }
    },
    components: {
        Hit
    },
    updated() {
        if(this.$store.getters.shouldFocus) {
            const hitsref = this.$refs.hit as Array<any>
            const listElementToFocus = hitsref[this.$store.getters.focusIndex].$el
            if(listElementToFocus) {
                const anchor = listElementToFocus.getElementsByTagName('a')[0];
                anchor.focus();
                const y = listElementToFocus.getBoundingClientRect().top + window.pageYOffset - 85;
                window.scrollTo({
                    top: y,
                    behavior: 'smooth'
                });
            }
        }
    }
})
